import { CURRICULUMS, MODULES, StudentServicePath } from "utils/constants";
import CreateModule from "./Create";
import permissions from "app/permissions";

export const resources = {
  name: StudentServicePath + MODULES + "/" + CURRICULUMS + "/:id/create",
  title: "Създай модул",
  custom: <CreateModule />,
  permission: permissions.canManageCurriculumModules,
};
